import { useMatches } from 'react-router-dom';
import { computeRoute } from '@vercel/speed-insights/react';

// Vercel Speed Insights needs a route *pattern* (e.g. "/home/vehicles/[id]"), not the resolved pathname -- otherwise every vehicle/user is its own "route" in the dashboard, and the ID (a capability token on the public share link) is sent to a third party. react-router-dom v6's useMatches exposes the resolved pathname and the matched params but not the raw path pattern from the route config, so computeRoute (from the same package, also used by its Next.js integration) reconstructs it by substituting each param's value back with its name.
export default function useTemplatedRoute(): string | null {
  const matches = useMatches();
  const match = matches[matches.length - 1];
  if (!match) {
    return null;
  }

  const params: Record<string, string> = {};
  Object.entries(match.params).forEach(([name, value]) => {
    if (value) {
      params[name] = value;
    }
  });

  return computeRoute(match.pathname, params);
}
